import { useQuery } from "@tanstack/react-query";
import axios from "axios";

// Generalized fetch function for reusability
const fetchResource = async ({ queryKey }) => {
	const [, endpoint] = queryKey;
	try {
		const response = await axios.get(endpoint);
		return response.data;
	} catch (error) {
		throw new Error(`Failed to fetch data from ${endpoint}: ${error.message}`);
	}
};

// Hook for fetching payment methods
//https://d4d2c7cf-d2b2-4337-86f0-f29dacad2eb5.mock.pstmn.io/checkout/profiles/6/paymethods
export const useFetchPaymentMethods = (profileId) => {
	const baseUrl = process.env.GATSBY_PAYMENT_METHODS_ENDPOINT; // Retrieve base URL from env
	let endpoint = "";

	if (profileId) {
		// If there is a profileId present, then construct the endpoint request
		endpoint = `${baseUrl}/${profileId}/paymentmethods`;
	} else {
		// If there is no profileId, then print a warning and abort fetching
		// console.warn(`Missing profile ID fir paymentmethods. Received: ${profileId}`);
	}

	return useQuery({
		queryKey: ["paymentMethods", endpoint, profileId], // Pass the endpoint as part of queryKey so the fetchResource can access it.
		queryFn: fetchResource, // Fetch function
		enabled: !!profileId, // Only fetch if there's a valid profileId
		retry: 2, // Retry failed requests twice
	});
};
